var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Renderer2 } from '@angular/core';
import { GameHostComponent } from '../game-host/game-host.component';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../shared/services/spinner.service';
import { MessageType } from '../shared/model/message-type';
import { GameStatus } from '../shared/model/game-status';
import { WindowsService } from '../shared/services/windows.service';
var PageScattergoriesHostComponent = /** @class */ (function (_super) {
    __extends(PageScattergoriesHostComponent, _super);
    function PageScattergoriesHostComponent(socketService, cookieService, router, resolver, renderer, spinnerService, windowService) {
        var _this = _super.call(this, socketService, cookieService, router, resolver, renderer, spinnerService, windowService) || this;
        _this.gameResults = [];
        _this.gamePrefix = 'S';
        _this.voteMode = false;
        _this.submitMode = false;
        _this.gameEndMode = false;
        _this.usersReady = false;
        _this.showUsers = true;
        return _this;
    }
    PageScattergoriesHostComponent.prototype.hostMessageHandler = function (message) {
        _super.prototype.hostMessageHandler.call(this, message);
        if (message.content.status === GameStatus.InProgress) {
            this.inProgressHandler(message);
        }
        else if (message.content.status === GameStatus.Complete) {
            this.sortUsers();
            this.showUsers = true;
            this.voteMode = false;
            this.submitMode = false;
            this.gameEndMode = true;
        }
    };
    PageScattergoriesHostComponent.prototype.sortUsers = function () {
        this.connectedUsers = this.connectedUsers.sort(function (a, b) {
            var number1 = a.currentScore;
            var number2 = b.currentScore;
            if (number1 > number2) {
                return -1;
            }
            return 1;
        });
    };
    PageScattergoriesHostComponent.prototype.responseHandler = function (message) {
        if (message.action === MessageType.Prompt) {
            if (message.content.status === GameStatus.InProgress) {
                this.inProgressHandler(message);
            }
        }
    };
    PageScattergoriesHostComponent.prototype.inProgressHandler = function (message) {
        this.usersReady = true;
        this.categories = message.content.cattergories;
        this.letter = message.content.letter;
        this.showUsers = false;
        this.voteMode = message.content.voteMode;
        this.submitMode = !this.voteMode;
    };
    return PageScattergoriesHostComponent;
}(GameHostComponent));
export { PageScattergoriesHostComponent };
